import clsx from 'clsx';
import Image, { ImageProps } from 'next/image';

import { getCompetitionLogoId, getCompetitionName } from '@/utils';
import { getAssetUrl } from '@/utils/getAssetUrl';
import { graphql, readFragment, type FragmentOf } from '@/utils/graphql';

export const competitionLogoFragment = graphql(`
  fragment competitionLogoFields on competitions {
    name
    logo {
      id
    }
    parent {
      name
      logo {
        id
      }
    }
  }
`);

export function CompetitionLogo({
  competition: _competition,
  size,
  ...props
}: Omit<ImageProps, 'src' | 'alt' | 'width' | 'height'> & {
  competition: FragmentOf<typeof competitionLogoFragment>;
  size: number;
}) {
  const competition = readFragment(competitionLogoFragment, _competition);

  const competitionName = getCompetitionName(competition);
  const competitionLogoId = getCompetitionLogoId(competition);

  if (!competitionLogoId) {
    const initials = competitionName.substring(0, 1).toUpperCase();

    return (
      <div
        className={clsx(
          `relative inline-flex items-center justify-center overflow-hidden bg-secondary rounded-xl flex-none`,
          props.className,
        )}
        style={{ width: size, height: size }}
      >
        <span className="font-medium text-primary">{initials}</span>
      </div>
    );
  }

  return (
    <Image
      src={getAssetUrl(competitionLogoId, {
        width: size * 2,
        height: size * 2,
      })}
      width={size}
      height={size}
      alt={`Logo de ${competitionName}`}
      className={clsx(
        `bg-secondary rounded-xl max-w-none inline-flex`,
        props.className,
      )}
      {...props}
    />
  );
}
